import React from "react";
import { Helmet } from "react-helmet";
import styled from "styled-components";

// Renders inside the SPA as a soft 404 (the HTTP status is still 200 because
// this is served from /index.html). The real 404 page is public/404.html and
// is served by CloudFront errorResponses for missing S3 keys. We render this
// component for extensionless URLs that don't match any route — without it,
// Google would see a thin page and potentially index it. The noindex directive
// keeps those soft 404s out of the index.
const NotFoundStyle = styled.section`
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
  text-align: center;

  .code {
    font-size: 96px;
    font-weight: 900;
    line-height: 1;
    color: var(--color-primary);
    margin: 0 0 16px;
    letter-spacing: -2px;
  }

  h1 {
    font-size: 24px;
    font-weight: 700;
    margin: 0 0 12px;
    color: #323a41;
  }

  p {
    color: #6b7280;
    line-height: 1.5;
    margin: 0 0 32px;
    max-width: 520px;
  }

  .actions {
    display: flex;
    gap: 12px;
    justify-content: center;
    flex-wrap: wrap;
  }

  a {
    display: inline-block;
    padding: 12px 24px;
    border-radius: 100px;
    font-weight: 700;
    text-decoration: none;
    font-size: 14px;
  }

  a.primary {
    background: var(--color-primary);
    color: #fff;
  }

  a.secondary {
    background: transparent;
    color: #323a41;
    border: 2px solid #e5e7eb;
  }
`;

function NotFound() {
  return (
    <>
      <Helmet>
        <title>Page Not Found | Propeller PH</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <NotFoundStyle>
        <div>
          <div className="code" aria-hidden="true">404</div>
          <h1>Page not found</h1>
          <p>The page you're looking for doesn't exist or may have been moved.</p>
          <div className="actions">
            <a className="primary" href="/">Back to home</a>
            <a className="secondary" href="/about-us">About Propeller PH</a>
          </div>
        </div>
      </NotFoundStyle>
    </>
  );
}

export default NotFound;
